import { useQuery } from "@tanstack/react-query";
import HTTPSCalls from "../Services/HTTPCalls";
import { useSelector } from "react-redux";
import { selectBatchState } from "../Store/Slice/batchSlice";
import { store } from "../Store/store";
import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import { adminContext } from "../Common/PageRoute";
import { showBatchFilter } from "./Utils";
import { EnquiryCallStatusEnum, EnquiryCounselorActionOptions } from "../Constant/Enums";
import { FromTo } from "../Types";
import { notification } from "antd";
import { IApiResponse } from "./ApiUtility.axios";
import { selectDepartmentState } from "../Store/Slice/departmentSlice";
import { ExamType } from "../Generated/orval-apis/cit.schemas";
import { useGetAPIDashBoardGetStudentStatus } from "../Generated/orval-apis/dash-board/dash-board";



// import axios from "axios";
// const batchState= useSelector((state:any)=>state.batch)

//For getting Schedule list name and id

interface Paggination{
  start?:number,
  length?:number,
  search?:string
  sortCol?:string
  sortdir?:string
  action?:EnquiryCounselorActionOptions
  counselorId?:string
}

export const GetListWithIdName = async (payload: any = {}) => {
  return HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_LIST_WITH_ID_NAME, payload);
};

export const useGetListWithIdName = (payload: any) => {
  return useQuery({
    queryKey: ["GetListWithIdName"],
    queryFn: () => GetListWithIdName(payload),
  });
};

export const getScheduleById = async (scheduleId: any = {}) => {
  return HTTPSCalls.GET(
    HTTPSCalls.ENDPOINTS.SCHEDULE_GET_BY_ID + "?id=" + scheduleId,
    {}
  );
};

export const useGetScheduleById = (scheduleId: any = "") => {
  return useQuery({
    queryKey: ["getScheduleById", scheduleId],
    queryFn: () => getScheduleById(scheduleId),
    enabled: !!scheduleId,
  });
};

//For getting Room list name and id
export const getMaster = async (payload: any = {}) => {
  return HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_MASTER_TYPE + "?", payload);
};

export const useGetMaster = (payload: any,localPath?:any) => {
  const storeData = store?.getState();
  const localCheck = localPath ? showBatchFilter(localPath):true;
  return useQuery({
    queryKey: ["GetMaster", payload],
    queryFn: () => getMaster(payload),
    enabled: !!storeData?.user?.id && localCheck,
  });
};

//For getting Schedule list items by Schedule id
export const getScheduleItemListById = async (payload: any = {}) => {
  return HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.SCHEDULE_ITEM_LIST + "?", payload);
};

export const useGetScheduleItemListById = (payload: any = "") => {
  return useQuery({
    queryKey: [
      "getScheduleItemListById",
      payload?.scheduleId,
      payload?.sectionId,
    ],
    queryFn: () => getScheduleItemListById(payload),
    enabled: !!payload?.scheduleId && !!payload?.sectionId,
  });
};

//For getting Schedule list items by Schedule id
export const GetEnquiryListWithIdName = async (search: string = "") => {
  return HTTPSCalls.GET(
    HTTPSCalls.ENDPOINTS.GET_ENQUIRY_LIST_WTIH_IDNAME + "?",
    { search }
  );
};

export const useGetEnquiryListWithIdName = (
  modelOpen: boolean = false,
  search: string = ""
) => {
  return useQuery({
    queryKey: ["EnquiryListWithIdName", search],
    enabled: modelOpen,
    queryFn: () => GetEnquiryListWithIdName(search),
  });
};

export const GetSubjectTypes = async (payload: any = {}) => {
  return HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.POST_MASTER + "?", payload);
};

export const UseSubjectTypes = (payload: any = {}, refresh: boolean) => {
  return useQuery({
    queryKey: ["GetSubjectTypes", payload, refresh],
    queryFn: () => GetSubjectTypes(payload),
  });
};

export const enquiryCommunicationGetById = async (payload: any) => {
  return await HTTPSCalls.GET(
    HTTPSCalls.ENDPOINTS.EnquiryCommunication_GETBYID + "?",
    payload
  );
};

export const useEnquiryCommunicationGetById = (payload: any) => {
  return useQuery({
    queryKey: ["CommunicationGetById", payload],
    queryFn: () => enquiryCommunicationGetById(payload),
    enabled: !!payload?.Id,
  });
};

export const batchAttendance = async (payload: any) => {
  let res = await HTTPSCalls.GET(
    HTTPSCalls.ENDPOINTS.GET_ALL_STUDENT_ATTENDANCE + "?",
    payload
  );
  // console.log("result",res?.result)
  let data = res?.result?.flatMap((el: any) => {
    if (el?.records && el?.records?.length > 0) {
      return el.records.map((item: any) => {
        return {
          name: el.name,
          id: el.id,
          Batch: el.batch,
          isLeave: el.isLeave,
          isHoliday: el.isHoliday,
          ...item,
        };
      });
    } else {
      return {
        name: el.name,
        id: el.id,
        studentId: el.studentId,
        Batch: el.batch,
        isLeave: el.isLeave,
        isHoliday: el.isHoliday,
        // ...el
      };
    }
  });
  return data;
};

export const useBatchAttendance = (payload: any) => {
  return useQuery({
    queryKey: ["GetAllStudentAttendance", payload],
    queryFn: () => batchAttendance(payload),
    // enabled:payload?.batchId?true:false
  });
};

export const getStudentStatus = async (batchState: any,departmentState:string) => {
  return await HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_STUDENT_STATUS + "?", {
    batchId: batchState,
    departmentId:departmentState
  })||{};
};

export const useGetStudentStatus = () => {
  const batchState = useSelector(selectBatchState);
  const departmentState = useSelector(selectDepartmentState);
let check = departmentState!==""?true:false;

return useGetAPIDashBoardGetStudentStatus({
  batchId: batchState,
  departmentId: departmentState
},{
  query:{
    enabled:check,
    queryKey: ["getStudentStatus", batchState,departmentState],
  }
});
  // return useQuery({
  //   queryKey: ["getStudentStatus", batchState,departmentState],
  //   queryFn: () => getStudentStatus(batchState,departmentState),
  //   enabled:check
  // });
};

export const updateMasterRecordStatus = async (payload:any) => {
  return await HTTPSCalls.POST(HTTPSCalls.ENDPOINTS.UPDATE_RECORD_STATUS+"?", {
    objId:payload.id,
    restore:payload.restore
  },{});
};

export const useUpdateMasterRecordStatus = () => {
  const { openNotification } = useContext(adminContext);
  return useMutation({
    mutationFn: (payload:any) => updateMasterRecordStatus(payload),
    onSuccess:()=>{
      openNotification("success","Action perform successfully")
    }, 
    onError:()=>{
      openNotification("error","SomeThing is wrong")
    }
  });
};

export const getAssessmentByDesignCourse = async (payload: any) => {
  let res= await HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_ASSESSMENT_BY_DESIGNCOURSE + "?", 
    payload,
  );
  return res?.result?.map((e:any)=>{
    return{
      label:e.assessmentName,
      value:e.id
    }
  })
};

export const useGetAssessmentByDesignCourse = (formValues:any) => {
  formValues=formValues.formData;
  let payload = {
    departmentId: formValues?.department || "",
    courseId: formValues?.course?.value || "",
    batchId: formValues?.batch?.value || "",
    semesterId: formValues?.semester?.value || "",
    sectionId: formValues?.section?.value || "",
  }
  let check = payload.sectionId?true:false;

  return useQuery({
    queryKey: ["getAssessmentByDesignCourse", payload.sectionId,payload.courseId,payload.batchId,payload.semesterId,payload.departmentId],
    queryFn: () => getAssessmentByDesignCourse(payload),
    enabled:check
  });
};

export const getAssessmentByDesignCourseForSingleStudent = async (payload: any) => {
  let res= await HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_ASSESSMENT_BY_DESIGNCOURSE_SINGLE_STUDENT + "?", 
    payload,
  );
  return res;
};

export const useGetAssessment2ByDesignCourse = (payload:any) => {
  let check = payload.semesterId!==""||payload.courseId!==""||payload.sectionId!==""?true:false;

  return useQuery({
    queryKey: ["getAssessmentByDesignCourse", payload.courseId,payload.semesterId,payload.sectionId,payload.categoryId,payload.assessmentId],
    queryFn: () => getAssessmentByDesignCourseForSingleStudent(payload),
    enabled:check
  });
};

export const getStudentByAssessment = async (payload: any) => {
  return await HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_STUDENT_BY_ASSESSMENT + "?", 
    payload,
  );
};

export const useGetStudentByAssessment = (payload:any) => {
  let check = payload.assessmentId?true:false;
  return useQuery({
    queryKey: ["getStudentByAssessment", payload.assessmentId],
    queryFn: () => getStudentByAssessment(payload),
    enabled:check
  });
};

export const saveAllSubjectMarks = async (payload:any) => {
  return await HTTPSCalls.POST(HTTPSCalls.ENDPOINTS.SAVE_ALL_SUBJECT_MARKS,{}, {
    ...payload
  });
};

export const useSaveAllSubjectMarks = () => {
  const { openNotification } = useContext(adminContext);
  return useMutation({
    mutationFn: (payload:any) => saveAllSubjectMarks(payload),
    onSuccess:()=>{
      openNotification("success","Action perform successfully")
    }, 
    onError:()=>{
      openNotification("error","SomeThing is wrong")
    }
  });
};

export const getStudentMarks = async (payload: any) => {
  return await HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_SUBJECT_MARKS + "?", 
    payload,
  );
};

export const useGetStudentMarks = (payload:any) => {
  let check = payload.assessmentId?true:false;
  return useQuery({
    queryKey: ["getStudentMarks", payload.assessmentId],
    queryFn: () => getStudentMarks(payload),
    enabled:check
  });
};

export const getAssessmentSubject = async (payload: any) => {
  return await HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_ASSESSMENT_SUBJECT + "?", 
    payload,
  );
};

export const useGetAssessmentSubject =(payload:any) => {
  let check = payload.assessmentId?true:false;
  return useQuery({
    queryKey: ["getAssessmentSubject", payload.assessmentId],
    queryFn: async() => {
    let res = await getAssessmentSubject(payload);
    return res?.result?.map((e:any)=>{
      return{
        label:e.name,
        value:e.id
      }
    })||[]
    },
    enabled:check
  });
};

export const getStudentByAssessmentSubject = async (payload: any) => {
  return await HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_STUDENT_BY_ASSESSMENT_SUBJECT + "?", 
    payload,
  );
};

export const useGetStudentByAssessmentSubject =(payload:any) => {
  let check = payload.subjectId?true:false;
  return useQuery({
    queryKey: ["getStudentByAssessmentSubject",payload.assessmentId, payload.subjectId],
    queryFn: async() => await getStudentByAssessmentSubject(payload),
    enabled:check
  });
};

export const getResultByDesignCourse = async (payload: any) => {
  return await HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_RESULT_BY_DESIGN_COURSE + "?", 
    payload,
  );
};

export const useGetResultByDesignCourse = (formValues:any,date:any) => {
  //formValues=formValues.formData;
  // console.log(date,"formValues",formValues)
  let payload = {
    departmentId: formValues?.department || "",
    courseId: formValues?.course?.value || "",
    batchId: formValues?.batch?.value || "",
    semesterId: formValues?.semester?.value || "",
    sectionId: formValues?.section?.value || "",
    studentId: formValues?.student?.value || "",
    categoryId: formValues?.category?.value || "",
    ...(date.length>0&&{From: date[0]}),
    ...(date.length>0&&{To: date[1]}),
  }
  let check = payload.sectionId?true:false;

  return useQuery({
    queryKey: ["getResultByDesignCourse", payload.sectionId,payload.studentId,payload.categoryId,date],
    queryFn: () => getResultByDesignCourse(payload),
    enabled:check
  });
};

export const getNotAssignedEnquiries = async (payload:Paggination) => {
  return await HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_NOT_ASSIGNED_ENQUIRIES+"?",{
    ...payload
  } );
};

export const useGetNotAssignedEnquiries = (payload:Paggination) => {
  return useQuery({
    queryKey: ["getNotAssignedEnquiries",payload],
    queryFn: () => getNotAssignedEnquiries(payload),
  });
};

export const getEnquiriesCallList = async (payload: {
  date: FromTo,
  callStatus: EnquiryCallStatusEnum,
  search?: string,
  counselor?: string,
}) => {
  
  const formattedPayload = {
    ...payload,
    from: payload.date.from.format("MM-DD-YYYY"),
    to: payload.date.to.format("MM-DD-YYYY"),
};

  return await HTTPSCalls.GET(
    HTTPSCalls.ENDPOINTS.GET_ENQUIRY_CALL_LIST + "?",
    formattedPayload
  );
};


export const useGetEnquiriesCallList = (payload:{
   date:FromTo,
   callStatus: EnquiryCallStatusEnum,
   search?:string,
   counselor?:string,
}) => {
  return useQuery({
    queryKey: ["getEnquiriesCallList",payload],
    queryFn: () => getEnquiriesCallList(payload),
  });
};

export const getEnquiriesCounselorList = async () => {
  return await HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_COUNSELORS_LIST+"?",{} );
};
export const useGetEnquiriesCounselorList = () => {
  return useQuery({
    queryKey: ["getEnquiriesCounselorList"],
    queryFn: () => getEnquiriesCounselorList(),
  });
};

export const getTimeScheduleByEnquiryId = async (enquiryId:string) => {
  let res = await HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_TIME_SCHEDULE_BY_ENQUIRY_ID+"?",{
    enquiryId
  });
  return res?.result||null;
};
export const useGetTimeScheduleByEnquiryId = (enquiryId:string) => {
  return useQuery({
    queryKey: ["getTimeScheduleByEnquiryId",enquiryId],
    queryFn: () => getTimeScheduleByEnquiryId(enquiryId),
    enabled: !!enquiryId
  });
};

 interface MonthlyReportInterface {
   batchId: string;
   year: string;
   month: string;
   searchTerm: string;
 }
 export const getMonthlyReport = async (payload: MonthlyReportInterface) => {
   let res = await HTTPSCalls.GET(
     HTTPSCalls.ENDPOINTS.GET_MONTHLY_REPORT + "?",
     payload
   );
   if (!res?.status) {
    //  openNotification("error", monthlyReport?.message);
    // message.error(res?.message||"Something went wrong",3);
    notification.info({
      message: 'Info',
      description:
        res?.message||"Something went wrong",
    });
    
   }
   return res;
 };
 export const useGetMonthlyReport = (payload: MonthlyReportInterface) => {
   return useQuery({
     queryKey: ["getMonthlyReport", payload.batchId, payload.year, payload.month, payload.searchTerm],
     queryFn: () => getMonthlyReport(payload),
     enabled: !!payload.batchId
   });
 };


 interface GetFeesMaster{
  id?:string,
  start?:number,
  length?:number,
  openDrawer?:boolean
 }

 export const getFeesMaster = async (payload: GetFeesMaster) => {
  let res = await HTTPSCalls.GET(
    HTTPSCalls.ENDPOINTS.GET_FEES_MASTER + "?",
    payload
  );
  if (!res?.status) {
   //  openNotification("error", monthlyReport?.message);
   // message.error(res?.message||"Something went wrong",3);
   notification.info({
     message: 'Info',
     description:
       res?.message||"Something went wrong",
   });
   
  }
  return res;
};
export const useGetFeesMaster = (payload: GetFeesMaster,trigger?:boolean) => {
  return useQuery({
    queryKey: ["getFeesMaster", trigger],
    queryFn: () => getFeesMaster(payload),
   enabled: !!payload?.openDrawer
  });
};

export const getWebEnquiry = async (payload: any) => {
  let res = await HTTPSCalls.GET(
    HTTPSCalls.ENDPOINTS.GET_WEB_ENQUIRY + "?",
    payload
  );
  if (!res?.status) {
   notification.info({
     message: 'Info',
     description:
       res?.message||"Something went wrong",
   });
   
  }
  return res;
};
export const useGetWebEnquiry = (payload: any) => {
  return useQuery({
    queryKey: ["getWebEnquiry", payload.start, payload.length, payload.search, payload.sortCol,payload.sortdir,payload.status],
    queryFn: () => getWebEnquiry(payload),
    // enabled: !!payload.batchId
  });
};

export const getCallLog = async (listParams: any) => {
  const res: IApiResponse = await HTTPSCalls.GET(
    `${HTTPSCalls.ENDPOINTS.TATA_CALL_LOG_LIST}?`,
    {
      search: listParams?.search,
      start: listParams.start,
      length: listParams?.length,
      sortCol: listParams?.sortCol,
      sortDir: listParams?.sortDir,
      enquiryStatus : listParams?.enquiryStatus,
      userNumber: listParams?.userNumber,
      ...(listParams?.from && listParams?.to
        ? { from: listParams?.from, to: listParams?.to }
        : {}),
        callStatusSearch:listParams?.callStatusSearch,
        callTypeSearch:listParams?.callTypeSearch,
    }
  );
  if (!res?.status) {
   notification.info({
     message: 'Info',
     description:
       res?.message||"Something went wrong",
   });
   
  }
  return res?.result;
};
export const useGetCallLogs = (listParams: any) => {
  return useQuery({
    queryKey: ["getCallLogs", listParams.search,
      listParams.start,
      listParams.length,
      listParams.sortCol,
      listParams.sortDir,
      listParams?.from,
      listParams?.to,
      listParams?.enquiryStatus,
      listParams?.callStatusSearch,
      listParams?.callTypeSearch,
      listParams?.userNumber
    ],
    queryFn: () => getCallLog(listParams),
    // enabled: !!payload.batchId
  });
};

export const getIndivitualStudentResult = async (payload: any) => {
  return await HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.Get_INDIVITUAL_STUDENT_RESULT + "?", 
    payload,
  );
};

export const useGetIndivitualStudentResult = (payload:{
  departmentId:string,
  courseId:string,
  batchId:string,
  semesterId:string,
  sectionId:string,
  studentId:string,
  categoryId:string,
  assessmentId:string,
}) => {
  let check = payload.studentId&&payload.courseId&&payload.semesterId&&payload.sectionId?true:false;

  return useQuery({
    queryKey: ["getIndivitualStudentResult", payload],
    queryFn: () => getIndivitualStudentResult(payload),
    enabled:check
  });
};


export const AddQuestionAndExamPaper  = async (payload:any) => {
  return await HTTPSCalls.POST(HTTPSCalls.ENDPOINTS.SAVE_QUESTION_AND_EXAM_PAPER, {},{
    ...payload
  });
};

export const useAddQuestionAndExamPaper = () => {
  const { openNotification } = useContext(adminContext);
  return useMutation({
    mutationFn: (payload:any) => AddQuestionAndExamPaper(payload),
    onSuccess:()=>{
      openNotification("success","Action perform successfully")
    }, 
    onError:()=>{
      openNotification("error","SomeThing is wrong")
    }
  });
};

export const getExamList = async (listParams: {
  search: string;
  start: string;
  length: string;
  sortCol: string;
  sortDir: string;
  departmentId: string;
  batchId: string;
}) => {
  const res: IApiResponse = await HTTPSCalls.GET(
    `${HTTPSCalls.ENDPOINTS.GET_EXAM_PAPER_LIST}?`,
    listParams
  );
  if (!res?.status) {
    notification.info({
      message: "Info",
      description: res?.message || "Something went wrong",
    });
  }
  return res;
};
export const useGetExamList = (listParams: any) => {
  return useQuery({
    queryKey: [
      "getExamList",
      listParams.search,
      listParams.start,
      listParams.length,
      listParams.sortCol,
      listParams.sortDir,
      listParams.departmentId,
      listParams.batchId,
      listParams?.semester
    ],
    queryFn: () => getExamList(listParams),
    enabled: !!listParams.departmentId,
  });
};

export const getAssessmentAndSubjectDetails = async (payload: {
  assessmentId: string;
  subjectId: string;
}) => {
  const res: IApiResponse = await HTTPSCalls.GET(
    `${HTTPSCalls.ENDPOINTS.GET_ASSESSMENT_AND_SUBJECT_DETAILS}?`,
    payload
  );
  if (!res?.status) {
    notification.info({
      message: "Info",
      description: res?.message || "Something went wrong",
    });
  }
  return res?.result || {};
};
export const useGetAssessmentAndSubjectDetails = (payload: {
  assessmentId: string;
  subjectId: string;
  type:ExamType
}) => {
  return useQuery({
    queryKey: ["getAssessmentAndSubjectDetails", payload.assessmentId, payload.subjectId,payload.type],
    queryFn: () => getAssessmentAndSubjectDetails(payload),
    enabled: !!payload.assessmentId && !!payload.subjectId,
  });
};

export const getExamPaperAndQuestionsDetails = async (payload: {
  assessmentId: string;
  subjectId: string;
}) => {
  const res: IApiResponse = await HTTPSCalls.GET(
    `${HTTPSCalls.ENDPOINTS.GET_EXAM_PAPER_AND_QUESTIONS_DETAILS}?`,
    payload
  );
  if (!res?.status) {
    notification.info({
      message: "Info",
      description: res?.message || "Something went wrong",
    });
  }
  return res||{};
};

export const useGetExamPaperAndQuestionsDetails = (payload: {
  assessmentId: string;
  subjectId: string;
  type:ExamType
}) => {
  return useQuery({
    queryKey: ["getExamPaperAndQuestionsDetails", payload.assessmentId, payload.subjectId,payload.type],
    queryFn: () => getExamPaperAndQuestionsDetails(payload),
    enabled: !!payload.assessmentId && !!payload.subjectId,
  });
};

export const getStudentExamList = async (payload: {
  start: number;
  length: number;
}) => {
  const res: IApiResponse = await HTTPSCalls.GET(
    `${HTTPSCalls.ENDPOINTS.GET_STUDENT_EXAM_LIST}?`,
    payload
  );
  if (!res?.status) {
    notification.info({
      message: "Info",
      description: res?.message || "Something went wrong",
    });
  }
  return res||{};
};

export const useGetStudentExamList = (payload: {
  start: number;
  length: number;
}) => {
  return useQuery({
    queryKey: ["getStudentExamList", payload.start, payload.length],
    queryFn: () => getStudentExamList(payload),
  });
};


export const UpdateStudentAnswer = async (payload:{
  studentId:string,
  examId:string,
  questionId:string,
  studentAnswer:string
}) => {
  return await HTTPSCalls.POST(HTTPSCalls.ENDPOINTS.UPDATE_STUDENT_ANSWER+"?", {},{
    studentId:payload.studentId,
    examId:payload.examId,
    questionId:payload.questionId,
    studentAnswer:payload.studentAnswer
  });
};

export const useUpdateStudentAnswer = () => {
  return useMutation({
    mutationFn: (payload:{
      studentId:string,
      examId:string,
      questionId:string,
      studentAnswer:any
    }) => UpdateStudentAnswer(payload),
    onSuccess: () => {
      notification.success({
        message: "Success",
        description: "Student answer updated successfully",
      });
    }
  });
};


//#region get Student's Answer Sheets List Req
interface getStudentAnswerSheetsListReq {
  search: string;
  start: number;
  length: number;
  sortCol: string;
  sortDir: string;
  examId: string;
}
export const getStudentAnswerSheetsList = async (listParams:getStudentAnswerSheetsListReq ) => {
  const res: IApiResponse = await HTTPSCalls.GET(
    `${HTTPSCalls.ENDPOINTS.GET_STUDENT_ANSWER_SHEETS_LIST}?`,
    listParams
  );
  if (!res?.status) {
    notification.info({
      message: "Info",
      description: res?.message || "Something went wrong",
    });
  }
  return res;
};
export const useGetStudentAnswerSheetsList = (listParams: getStudentAnswerSheetsListReq) => {
  return useQuery({
    queryKey: [
      "getStudentAnswerSheetsList",
      listParams.search,
      listParams.start,
      listParams.length,
      listParams.sortCol,
      listParams.sortDir,
      listParams.examId,
    ],
    queryFn: () => getStudentAnswerSheetsList(listParams),
    enabled: !!listParams.examId,
  });
};

//#endregion


//#region get individual Student's Answer Sheets
interface getExamIndividualStudentAnswerSheetReq {
  examId: string;
  studentId: string;
}
export const getExamIndividualStudentAnswerSheet = async (listParams:getExamIndividualStudentAnswerSheetReq ) => {
  const res: IApiResponse = await HTTPSCalls.GET(
    `${HTTPSCalls.ENDPOINTS.GET_EXAM_INDIVIDUAL_STUDENT_ANSWER_SHEET}?`,
    listParams
  );
  if (!res?.status) {
    notification.info({
      message: "Info",
      description: res?.message || "Something went wrong",
    });
  }
  return res?.result||{};
};
export const useGetExamIndividualStudentAnswerSheet = (listParams: getExamIndividualStudentAnswerSheetReq) => {
  return useQuery({
    queryKey: [
      "getExamIndividualStudentAnswerSheet",
      listParams.examId,
      listParams.studentId,
    ],
    queryFn: () => getExamIndividualStudentAnswerSheet(listParams),
    enabled: !!listParams.examId && !!listParams.studentId,
  });
};

//#endregion


export const getBatchByDepartment = async (payload: any = {}) => {
  return HTTPSCalls.GET(HTTPSCalls.ENDPOINTS.GET_BATCH_BY_DEPARTMENT + "?", payload);
};

export const useGetBatchByDepartment = (payload: any,localPath?:any) => {
  const storeData = store?.getState();
  const departmentId = payload?.departmentId || storeData?.department?.departmentId;
  const localCheck = localPath ? showBatchFilter(localPath):true;
  return useQuery({
    queryKey: ["getBatchByDepartment", departmentId],
    queryFn: () => getBatchByDepartment({departmentId:departmentId}),
    enabled: !!storeData?.user?.id && localCheck && !!departmentId,
  });
};